"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { SortDirection } from "@/entities/ISort";
import type { XtdhTokensOrder, XtdhTokensSortField } from "@/hooks/useXtdhTokensQuery";
import { DEFAULT_TOKEN_CONTRIBUTORS_GROUP_BY, DEFAULT_TOKEN_CONTRIBUTORS_SORT_DIRECTION, DEFAULT_TOKEN_CONTRIBUTORS_SORT_FIELD, parseTokenContributorsGroupBy, parseTokensSortDirection, parseTokensSortField, type XtdhTokenContributorsGroupBy } from "@/components/xtdh/received/constants";
const SORT_PARAM = "xtdh_token_contrib_sort";
const DIRECTION_PARAM = "xtdh_token_contrib_dir";
const GROUP_PARAM = "xtdh_token_contrib_group";
interface XtdhTokenContributorsFiltersResult {
  readonly activeSortField: XtdhTokensSortField;
  readonly activeSortDirection: SortDirection;
  readonly activeGroupBy: XtdhTokenContributorsGroupBy;
  readonly apiOrder: XtdhTokensOrder;
  readonly handleSortChange: (sort: XtdhTokensSortField) => void;
  readonly handleGroupByChange: (group: XtdhTokenContributorsGroupBy) => void;
}
export function useXtdhTokenContributorsFilters() {
  const $ = _c(27);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = parseTokensSortField(searchParams?.get(SORT_PARAM) ?? null);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activeSortField = t0;
  let t1;
  if ($[2] !== searchParams) {
    t1 = parseTokensSortDirection(searchParams?.get(DIRECTION_PARAM) ?? null);
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const activeSortDirection = t1;
  let t2;
  if ($[4] !== searchParams) {
    t2 = parseTokenContributorsGroupBy(searchParams?.get(GROUP_PARAM) ?? null);
    $[4] = searchParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const activeGroupBy = t2;
  const apiOrder = activeSortDirection === SortDirection.ASC ? "ASC" : "DESC";
  let t3;
  if ($[6] !== pathname || $[7] !== router || $[8] !== searchParams) {
    t3 = (sort, direction) => {
      if (!pathname) {
        return;
      }
      const params = new URLSearchParams(searchParams?.toString() ?? "");
      if (sort === DEFAULT_TOKEN_CONTRIBUTORS_SORT_FIELD) {
        params.delete(SORT_PARAM);
      } else {
        params.set(SORT_PARAM, sort);
      }
      if (direction === DEFAULT_TOKEN_CONTRIBUTORS_SORT_DIRECTION) {
        params.delete(DIRECTION_PARAM);
      } else {
        params.set(DIRECTION_PARAM, direction.toLowerCase());
      }
      const query = params.toString();
      router.replace(query ? `${pathname}?${query}` : pathname, {
        scroll: false
      });
    };
    $[6] = pathname;
    $[7] = router;
    $[8] = searchParams;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const updateSortParams = t3;
  let t4;
  if ($[10] !== pathname || $[11] !== router || $[12] !== searchParams) {
    t4 = group => {
      if (!pathname) {
        return;
      }
      const params_0 = new URLSearchParams(searchParams?.toString() ?? "");
      if (group === DEFAULT_TOKEN_CONTRIBUTORS_GROUP_BY) {
        params_0.delete(GROUP_PARAM);
      } else {
        params_0.set(GROUP_PARAM, group);
      }
      const query_0 = params_0.toString();
      router.replace(query_0 ? `${pathname}?${query_0}` : pathname, {
        scroll: false
      });
    };
    $[10] = pathname;
    $[11] = router;
    $[12] = searchParams;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const updateGroupByParam = t4;
  let t5;
  if ($[14] !== activeSortDirection || $[15] !== activeSortField || $[16] !== updateSortParams) {
    t5 = sort_0 => {
      const toggledDirection = activeSortDirection === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
      const nextDirection = sort_0 === activeSortField ? toggledDirection : DEFAULT_TOKEN_CONTRIBUTORS_SORT_DIRECTION;
      updateSortParams(sort_0, nextDirection);
    };
    $[14] = activeSortDirection;
    $[15] = activeSortField;
    $[16] = updateSortParams;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const handleSortChange = t5;
  let t6;
  if ($[18] !== updateGroupByParam) {
    t6 = group_0 => {
      updateGroupByParam(group_0);
    };
    $[18] = updateGroupByParam;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const handleGroupByChange = t6;
  let t7;
  if ($[20] !== activeGroupBy || $[21] !== activeSortDirection || $[22] !== activeSortField || $[23] !== apiOrder || $[24] !== handleGroupByChange || $[25] !== handleSortChange) {
    t7 = {
      activeSortField,
      activeSortDirection,
      activeGroupBy,
      apiOrder,
      handleSortChange,
      handleGroupByChange
    };
    $[20] = activeGroupBy;
    $[21] = activeSortDirection;
    $[22] = activeSortField;
    $[23] = apiOrder;
    $[24] = handleGroupByChange;
    $[25] = handleSortChange;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}